import { type, type Type } from 'arktype';

export const timetrackingPersonQuerySchema = type({
  'personId?': 'string',
});

export type TimetrackingPersonQuery = typeof timetrackingPersonQuerySchema.t;

export const createTimetrackingPersonSchema = type({
  personId: 'string',
});

export type CreateTimetrackingPerson = typeof createTimetrackingPersonSchema.t;

export interface PersonRef {
  id: string;
  displayName: string;
}

export const personRefSchema: Type<PersonRef> = type({
  id: 'string > 0',
  displayName: 'string > 0',
}).onUndeclaredKey('reject');

export interface TimetrackingPerson {
  id: string;
  personId: string;
  createdAt: string;
  updatedAt: string;
}
